export default __webpack_public_path__ + "static/media/minus-black.917d42a5.png";